export const OFFER_CREATED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferCreated";
export const OFFER_ASSET_CREATED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Assets.OfferAssetCreated";
export const OFFER_ASSET_UPDATED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Assets.OfferAssetUpdated";
export const FROM_PARTNER_QUERY_FOUND =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Assets.PartnerQueryFound";
export const OFFER_ASSET_DELETED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Assets.OfferAssetDeleted";
export const OFFER_ASSET_CHASSIS_NO_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Assets.OfferAssetChassisNumberUpdated";
export const ASSET_SPLIT = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Assets.AssetSplit";
export const ASSET_INFORMATION_SAVED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Assets.AssetInformationSaved";
export const ASSET_INFORMATION_DELETED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Assets.AssetInformationDeleted";
export const OFFER_ASSET_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Assets.OfferAssetInvalidated";
export const ASSET_DATA_RETRIEVED = "Charisma.Leasing.PublishedLanguage.Events.Asset.AssetDataRetrieved";
